import { render, staticRenderFns } from "./edit-AI-tzcp.vue?vue&type=template&id=cb7e5dfe&scoped=true"
import script from "./edit-AI-tzcp.vue?vue&type=script&lang=ts"
export * from "./edit-AI-tzcp.vue?vue&type=script&lang=ts"
import style0 from "./edit-AI-tzcp.vue?vue&type=style&index=0&id=cb7e5dfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7e5dfe",
  null
  
)

export default component.exports